<template>
  <div class="content-container" v-loading="loading">
    <ContentBox title="基本信息" class="content-box">
      <el-form
        :rules="rules"
        ref="landingPageForm"
        :model="landingPageForm"
        label-width="120px"
        hide-required-asterisk
        label-position="left"
        class="base-form"
      >
        <el-row>
          <el-col :span="14">
            <el-form-item label="名称" prop="landingPageName">
              <el-input v-model.trim="landingPageForm.landingPageName" v-noEmoji maxlength="45" show-word-limit placeholder="请输入落地页名称"></el-input>
            </el-form-item>
            <el-form-item v-if="accountType === '1'" label="广告主" prop="partnerId">
              <el-select :disabled="isEditMode || disabled" v-model="landingPageForm.partnerId" clearable filterable placeholder="请选择广告主">
                <el-option v-for="(item, index) in partnerOptions" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="落地页类型" prop="landingPageClassId">
              <el-radio-group
                :disabled="uploadDisabled || isEditMode"
                :value="landingPageForm.landingPageClassId"
                @input="handleChangeType($event)"
              >
                <el-radio
                  class="code-radio"
                  v-for="(item, index) in landingPageClassOptions"
                  :label="item.landingPageClassId"
                  :key="index"
                >{{ item.landingPageClassName }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <template v-if="status === 'uploading'">
                <div class="base-form-upload">
                  <div style="display: flex; padding: 10px 0px">
                    <el-progress :width="120" type="circle" :percentage="percentage"></el-progress>
                  </div>
                </div>
              </template>
              <template v-else>
                <template v-if="mode === 'create'">
                  <el-upload
                    class="base-form-upload"
                    action="#"
                    :accept="acceptFormat"
                    :show-file-list="false"
                    :http-request="uploadFile"
                    :before-upload="beforeUploadFile"
                    element-loading-text="上传中，请稍后……"
                    v-loading="loading"
                  >
                    <template v-if="imageUrl">
                      <div class="img_div">
                        <div class="show-img-box">
                          <el-image :src="imageUrl" cover></el-image>
                        </div>
                        <div class="mask">
                          <div class="mask-button">
                            <el-button @click="clearImg">重新上传</el-button>
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div>
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">点击上传落地页</div>
                      </div>
                      <div slot="tip" class="el-upload__tip">{{ landingPageDesc }}</div>
                    </template>
                  </el-upload>
                </template>
                <template v-else>
                  <div class="base-form-upload">
                    <el-image :src="imageUrl" cover style="width: 200px; padding: 10px 0px"></el-image>
                  </div>
                </template>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </ContentBox>
    <ContentBox class="content-box">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :loading="saveLoading" @click="handleSave">保存</el-button>
    </ContentBox>
  </div>
</template>

<script>
import SparkMD5 from 'spark-md5'

export default {
  props: {
    mode: {
      type: String,
      default: 'create'
    },
    landingPageId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      isEditMode: false, // 是否可以编辑
      disabled: false,
      uploadDisabled: false, // 上传中禁用
      partnerOptions: [], // 广告主options
      landingPageClassOptions: [], // 落地页类型options
      landingPageForm: {
        landingPageName: '',
        partnerId: '',
        landingPageClassId: '',
      },
      acceptFormat: '',
      landingPageDesc: '',
      percentage: 0,
      md5: null,
      status: 'none',
      imageUrl: '',
      saveLoading: false,
      rules: {
        landingPageName: [{ required: true, message: '请输入落地页名称', trigger: 'blur' }],
        partnerId: [{ required: true, message: '请选择广告主', trigger: 'blur' }],
        landingPageClassId: [{ required: true, message: '请选择落地页类型', trigger: 'blur' }]
      }
    }
  },
  computed: {},
  methods: {
    handleChangeType(landingPageClassId) {
      if (this.imageUrl === '') {
        this.percentage = 0
        this.status = 'none'
        this.disabled = false
        this.landingPageForm.landingPageClassId = landingPageClassId
        this.initUpload(landingPageClassId)
      } else {
        this.$confirm('修改落地页类型将清空已上传素材，确认修改?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center: true,
          showClose: false
        })
          .then(() => {
            this.landingPageForm = {
              landingPageName: this.landingPageForm.landingPageName,
              partnerId: this.landingPageForm.partnerId,
              landingPageClassId: landingPageClassId,
            }
            this.imageUrl = ''
            this.percentage = 0
            this.status = 'none'
            this.disabled = false
            this.initUpload(landingPageClassId)
          })
          .catch(() => {
            this.percentage = 0
            this.status = 'none'
          })
      }
    },
    beforeUploadFile(uploadFile) {
      this.uploadDisabled = true
    },
    uploadFile(paramsFile, fileItem) {
      this.percentage = 0
      this.status = 'uploading'
      this.imageUrl = ''
      let fileReader = new FileReader()
      let dataFile = paramsFile.file
      let spark = new SparkMD5() // 创建md5对象（基于SparkMD5）
      fileReader.readAsBinaryString(dataFile)
      fileReader.onload = function (e) {
        spark.appendBinary(e.target.result)
        this.md5 = spark.end()
        const intervalId = setInterval(() => {
          if (this.percentage < 99) {
            this.percentage += 1
          }
        }, 1560)
        this.$service
          .landingPageUpload({
            file: paramsFile.file,
            md5: this.md5,
            landingPageClassId: this.landingPageForm.landingPageClassId,
          })
          .then(data => {
            if (data.success || data.code === '40000' || data.code === 0) {
              this.percentage = 100
              setTimeout(() => {
                this.status = 'success'
                this.imageUrl = data.data.landingPageIcon
                this.landingPageForm = {
                  ...this.landingPageForm,
                  ...data.data
                }
                this.uploadDisabled = false
                window.clearInterval(intervalId)
              }, 300)
            } else {
              this.percentage = 0
              this.status = 'error'
              this.uploadDisabled = false
              window.clearInterval(intervalId)
              this.$message.error(data.message)
            }
          })
          .catch(e => {
            this.percentage = 0
            window.clearInterval(intervalId)
            this.status = 'error'
            this.uploadDisabled = false
          })
      }.bind(this)
    },
    clearImg() {
      this.initUpload(this.landingPageForm.landingPageClassId)
    },
    initUpload(landingPageClassId) {
      this.handleUploadTip()
    },
    // 获取广告主数据
    getPartnerData() {
      this.partnerOptions = []
      if (this.accountType === '1') {
        this.$service.getAvailableCustomer().then(data => {
          this.partnerOptions = (data || [])
            .filter(item => item.parentId !== 0)
            .map(item => {
              return {
                value: item.partnerId,
                label: item.partnerName
              }
            })
        })
      }
    },
    // 获取落地页类型数据
    getLandingPageClassData() {
      this.landingPageClassOptions = []
      this.$service.getLandingPageClass({}).then(res => {
        this.landingPageClassOptions = res || []
        this.landingPageForm.landingPageClassId = res[0].landingPageClassId
        this.handleUploadTip()
      })
    },
    handleUploadTip() {
      const landingPageClass = this.landingPageClassOptions.find(item => item.landingPageClassId === this.landingPageForm.landingPageClassId)
      const limits = landingPageClass.landingPageLimitList
      const duration = `${limits[0].minDuration}-${limits[0].maxDuration}s`
      const size = limits.map(item => {
        return `${item.width}*${item.height}/小于${item.size}kb`
      }).join(',')
      const format = landingPageClass.landingPageFormat.split(',').join('/')
      this.landingPageDesc = `${size},${format},时长${duration},必须带有声音`
    },
    getLandingPageInfo() {
      this.$service
        .getLandingPageInfo({ landingPageId: this.landingPageId })
        .then((data) => {
          if (data) {
            this.landingPageForm = data
            this.imageUrl = data.landingPageIcon
            this.loading = false
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    handleCancel() {
      this.$emit('go-back')
    },
    buildSaveParam() {
      if (this.mode === 'create') {
        return this.landingPageForm
      } else {
        return {
          landingPageId: this.landingPageForm.landingPageId,
          landingPageName: this.landingPageForm.landingPageName
        }
      }
    },
    handleSave() {
      this.$refs.landingPageForm.validate((valid) => {
        const params = this.buildSaveParam()
        if (this.mode === 'create' && !params.landingPageIcon) {
          this.$message.error('请点击上传素材')
          return
        }
        if (valid && params) {
          this.saveLoading = true
          const serviceName = this.mode === 'edit' ? 'editLandingPage' : 'addLandingPage'
          this.$service[serviceName](params).then((res) => {
            this.$message.success('保存成功！')
            this.saveLoading = false
            this.$emit('go-back')
          })
            .catch(() => {
              this.saveLoading = false
            })
        }
      })
    }
  },
  created() {
    this.accountType = this.$service.state.user.accountType
    // 0: 广告主
    if (this.accountType === '0') {
      this.landingPageForm.partnerId = this.$service.state.user.partnerId
    }
    this.getPartnerData()
    this.getLandingPageClassData()
    if (this.mode === 'edit' && this.landingPageId) {
      this.isEditMode = true
      this.getLandingPageInfo()
    }
  }
}
</script>

<style lang="stylus" scoped>
.content-container
  margin 16px
.base-form .el-select
  width 100%
.base-form-upload
  border 1px dashed #d9d9d9
  display flex
  flex-direction column
  align-items center
  >>>.el-upload
    display block
    margin 10px
  >>>.el-icon-upload
    font-size 40px
    width 52px
    height 43px
    color rgba(255, 139, 0, 0.5)
  .el-upload__text
    color #999
  .el-upload__tip
    margin 0
    width 90%
    overflow-wrap break-word
    text-align center
.el-radio-button >>>.el-radio-button__inner
  min-width 90px
.show-img-box
  height 100%
  width 100%
  display flex
.show-img-box img
  width 100%
.img_div
  position relative
  width 200px
.mask
  position absolute
  top 0
  left 0
  height 100%
  width 100%
  background rgba(101, 101, 101, 0.6)
  color #ffff f
  opacity 0
.mask-button
  display flex
  height 100%
  justify-content center
  align-items center
.img_div:hover .mask
  opacity 1
.code-radio:first-child
  border-left 1px solid #dcdfe6
  border-radius 4px 0 0 4px
  box-shadow none !important
.code-radio:last-child
  border-radius 0 4px 4px 0
.code-radio
  width 100px
  color #606266
  cursor pointer
  padding 10px 20px !important
  border 1px solid #DCDFE6
  border-left 0
  margin 0px
  white-space nowrap
  background #fff
  text-align center
  box-sizing border-box
  outline 0
  margin 0
  position relative
  transition all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1)
  >>> .el-radio__label
    padding 0px
  >>> .el-radio__input
    position absolute
    opacity 0
    z-index -1
    left 0
    top 0
.code-radio.is-checked
  border-color #FF8B00
  background-color rgba(255, 139, 0, 0.1)
  box-shadow -1px 0 0 0 #FF8B00
.code-radio:hover
  color #ff8b00
.code-radio:check
  color FF8B00
.code-radio.is-disabled
  background-color #fff
  cursor not-allowed
  background-image none
  border-color #EBEEF5
  box-shadow -1px 0 0 0 #F2F6FC
.code-radio.is-disabled.is-checked
  background-color #F2F6FC
</style>
